import React from 'react';
import { App } from 'App';
import { Theme } from 'theme';
import { store } from 'store/store';
import { Provider } from 'react-redux';
import { DndProvider } from 'react-dnd';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'components';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { notificationService } from 'services/NotificationService';
import reportWebVitals from './reportWebVitals';
import './index.css';

notificationService.setDispatch(store.dispatch);
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <ConfigProvider theme={Theme}>
      <DndProvider backend={HTML5Backend}>
        <App />
      </DndProvider>
    </ConfigProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
